import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  subTitleLoadingStyle: {
    color: Colors.red,
  },
  lottieViewStyle: {
    width: 116,
    height: 116,
  },
  iconContainerStyle: {
    marginBottom: 30,
  },
  lottieViewContainerStyle: {
    marginBottom: 16,
  },
});
